// src/components/layouts/private/PublicNavBar.jsx (o donde tengas la nav pública)
import React from "react";
import { Box } from "@mui/material";

export const Nav = () => {
  return (
    <Box
      component="nav"
      aria-label="Navegación pública"
      sx={{
        height: 56,                 // misma “sensación” de navbar
        bgcolor: "primary.main",    // barra azul del tema
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
      }}
    />
  );
};
